<template>
  <div v-if="isRouterAlive">
    <Slider
      :banner="`https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/news.jpg`"
    >
      <div class="row align-items-center">
        <div class="col fontsiyuanmedium">
          <div class="slider-news4-title fontsiyuanmedium">
            {{ $t("slidertitle") }}
          </div>
          <div class="slider-news4-subtitle fontsiyuanregular">
            {{ $t("slidersubtitle") }}
          </div>
        </div>
      </div>
    </Slider>
    <div>
      <div class="news-title-wide news-title-group sticky2" style="text-align: center">
        <b-container>
          <div class="row justify-content-center">
            <div
              :class="`col-md-2 col-sm-3 news-title ${
                index == active ? 'active' : ''
              }`"
              @click="change(index)"
              v-for="(item, index) in $t('title2list')"
              v-bind:key="index"
            >
              <span>{{ item }}</span>
            </div>
          </div>
        </b-container>
      </div>
      <div class="news-title-thin">
        <b-container>
          <div class="news-title-header" @click="visible1 = !visible1">
            <span class="news-title-title">{{ $t("title2list")[2] }}</span>
            <span class="news-title-button"
              ><b-img v-if="!visible1" :src="colarrowdown"></b-img
              ><b-img v-if="visible1" :src="colarrowup"></b-img
            ></span>
          </div>
          <b-collapse
            v-model="visible1"
            class="thin-item-body"
            style="z-index: 1703"
          >
            <div class="news-title-header" @click="change(0)">
              <span class="news-title-title">{{ $t("title2list")[0] }}</span>
            </div>
            <div class="news-title-header" @click="change(1)">
              <span class="news-title-title">{{ $t("title2list")[1] }}</span>
            </div>
            <div class="news-title-header" @click="change(3)">
              <span class="news-title-title">{{ $t("title2list")[3] }}</span>
            </div>
          </b-collapse>
        </b-container>
      </div>

      <div class="news-list">
        <waterfall :line-gap="430" align="center" :watch="imgList" v-if="isRouterAlive" >
          <!-- each component is wrapped by a waterfall slot -->
          <waterfall-slot
            
            v-for="(item, index) in $t(newslistname)"
            :width="item.newswidth"
            :height="item.newsheight"
            :order="index"
            :key="index"
          >
            <b-img :src="item.newslink" />
            <!--
      your component
    -->
          </waterfall-slot>
        </waterfall>
        <div class="product-load">
          <b-row>
            <b-col cols="2" lg="4"> </b-col>
            <b-col cols="8" lg="4" style="text-align: center">
              <span>

                {{$t('showed')}}{{ newslist.length }}{{$t('product')}}/{{$t('all')}}{{ rows }}{{$t('product')}}
              </span>

              <b-progress :max="rows" class="mt-2" variant="gray" height="3px">
                <b-progress-bar :value="newslist.length">
                  <span> </span>
                </b-progress-bar>
              </b-progress>

              <b-button
                variant="outline-secondary"
                class="product-load-more"
                v-if="newslist.length < rows"
                @click="loadmore()"
                >{{$t('loadmore')}}</b-button
              >
            </b-col>
            <b-col cols="2" lg="4"> </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div></div>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import Waterfall from "vue-waterfall/lib/waterfall";
import WaterfallSlot from "vue-waterfall/lib/waterfall-slot";
import Sticky from "sticky-js";
export default {
  components: {
    Slider,
    Footer,
    Waterfall,
    WaterfallSlot,
  },
  data() {
    return {
      isRouterAlive: true,

      active: 2,
      newslist: [],

      limit: 12,
      page: 1,
      type: 0,

      rows: 0,

      visible1: false,

      newslistname:''

    };
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getNews() {
      const _this = this;
      this.$store.dispatch("getNews").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
      });
    },
    change(index) {
      this.$router.push({
        path: `/news${2 + parseInt(index)}`,
      });
    },

    getMediaPage() {
      const _this = this;
      this.isRouterAlive = false;
      this.$store
        .dispatch("getMediaPage", {
          limit: _this.limit,
          page: _this.page,
          type: _this.active,
        })
        .then((data) => {
          _this.newslist=_this.newslist.concat(data.list)
          _this.rows = data.total;
          let zh = [];
          let en = [];
          data.list.forEach((element) => {
            zh.push({
              newsid: element.id,
              newslink: element.link,
              newswidth: element.width,
              newsheight: element.height,
            });
            en.push({
              newsid: element.id,
              newslink: element.link,
              newswidth: element.width,
              newsheight: element.height,
            });
          });
          _this.newslistname = `newslist${new Date().getTime()}`;
          let enObj = {};
          let zhObj = {};
          enObj[_this.newslistname] = en;
          zhObj[_this.newslistname] = zh;
          _this.$i18n.mergeLocaleMessage("en", enObj);
          _this.$i18n.mergeLocaleMessage("zh", zhObj);

          let lang = _this.$i18n.locale;
          _this.$i18n.locale = lang;
          _this.reload();
          _this.isRouterAlive = true;


          const sticky2 = new Sticky(".sticky2");
          sticky2.update();
        });
    },
    viewnews(index,key,item) {
      const _this = this;
      if (parseInt(key) == 1&&localStorage.getItem('pwd')!='access') {
        _this.$bvToast.toast(
          `该文章需要密码才可以打开，3秒后将跳转到密码登录页！`,
          {
            title: "警告",
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
            variant: "danger",
          }
        );

        _this.$store.state.loginpath = item.newslink
        _this.$store.state.loginmode = 'out'
        setTimeout(function () {
          _this.$router.push("/login");
        }, 3000);
      }else{

        window.open(item.newslink,'_blank')
      }
    },
  },
  mounted() {
    this.newslist=[];
    this.active = 2;
    // this.demo();
    this.getNews();
    this.getMediaPage();
  },
};
</script>
<style>
.grid {
  margin-top: 50px;
}
/* clear fix */
.grid:after {
  content: "";
  display: block;
  clear: both;
}

/* ---- .grid-item ---- */

.grid-sizer,
.grid-item {
  width: 33.333%;
  padding: 10px;
}

.grid-item {
  float: left;
}

.grid-item img {
  display: block;
  width: 100%;
}

.slider-news4-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-news4-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  border-bottom: 0.5px #bdbdbd88 solid;
  height:75px;
}
.news-title {
  padding: 25px 0;
  cursor: pointer;
}
.news-title span {
  padding: 28px 0;
}
.news-title span:hover {
  color: #c00f31;
  font-weight: 800;
  border-bottom: 3px solid #c00f31;
}
.news-title.active span {
  border-bottom: 3px solid #c00f31;
}
.news-title.active {
  color: #c00f31;
  font-weight: 800;
}
.news-list {
  padding-bottom: 100px;
  padding-top: 50px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 50px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  color: #8a8a8a;
}
@media only screen and (max-width: 500px) {
  .slider-news4-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-news4-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}

.product-load {
  margin-top: 50px;
}
.progress {
  background-color: #c0c4c8;
}
.progress-bar {
  background-color: #808080;
}

.product-load-container {
  text-align: center;
  white-space: nowrap;
}
.product-load-more {
  white-space: nowrap;
  margin-top: 50px;
  font-weight: 300;
  color: #c0c4c8;
  border: 1px #c0c4c8 solid;
  border-radius: 0;
  padding-left: 50px;
  padding-right: 50px;
}
.product-load-more:hover {
  box-shadow: #00000034 0px 0px 0px;
}
.product-load-more:after {
  box-shadow: #00000034 0px 0px 0px;
}

.news-title-thin {
  display: none;
}
@media only screen and (max-width: 500px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
  .news-title-button img {
    width: 15px;
    position: absolute;
    right: 30px;
  }
  .news-title-header {
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px #bdbdbd44 solid;
  }

  .product-load-more {
    margin-top: 50px;
  }
}
</style>
